export default "__VITE_ASSET__CBWSzpFe__"